export default __webpack_public_path__ + "static/background-shapes-def1501314bf7f4f1389e9b51ab092a5.svg";